import { api } from "./api";
import { adaptList, adaptMovie, adaptPage } from "@/lib/adapters";

export async function getHome({ signal } = {}) {
  const res = await api.get("/home", { signal });
  return {
    hero: adaptList(res.hero),
    rows: (res.rows || []).map((r) => ({ key: r.key, title: r.title, href: r.href, items: adaptList(r.items) })).filter((r) => r.items.length),
    total: res.total || 0,
  };
}

export const getTrending = async ({ page = 1, signal } = {}) => adaptPage(await api.get("/movies", { params: { sort: "popular", page }, signal }));

export async function searchMovies({ q = "", page = 1, genre, type, sort, signal } = {}) {
  const params = { q, page, limit: 24 };
  if (genre) params.genre = genre;
  if (type) params.type = type;
  if (sort) params.sort = sort;
  return adaptPage(await api.get("/search", { params, signal }));
}

export async function browseMovies({ page = 1, genre, type, sort = "popular", signal } = {}) {
  const params = { page, limit: 24, sort };
  if (genre) params.genre = genre;
  if (type) params.type = type;
  return adaptPage(await api.get("/movies", { params, signal }));
}

export const getMovie = async (id, { signal } = {}) => adaptMovie(await api.get(`/movies/${encodeURIComponent(id)}`, { signal }));
export const getSimilar = async (id, { signal } = {}) => adaptList((await api.get(`/movies/${encodeURIComponent(id)}/similar`, { signal })).items);

export async function getCategories({ signal } = {}) {
  const res = await api.get("/genres", { signal });
  return { items: res.items || [], qualities: res.qualities || [] };
}

export async function getCategory(slug, { page = 1, sort = "popular", signal } = {}) {
  const res = await api.get(`/categories/${encodeURIComponent(slug)}`, { params: { page, sort, limit: 24 }, signal });
  return { ...adaptPage(res), genre: res.genre };
}
